import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from "@shared/shared.module";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgxMaskDirective } from "ngx-mask";

@Component({
  selector: 'scope-ui-box-input',
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule, NgxMaskDirective],
  templateUrl: './scope-ui-box-input.component.html',
  styleUrls: ['./scope-ui-box-input.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        width: '200px'
      })),
      state('expanded', style({
        width: '400px'
      })),
      transition('collapsed <=> expanded', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class ScopeUiBoxInputComponent {
  @Input() initialValue: number
  @Input() formClass?: string
  @Input() isDecimal?: boolean
  @Input() min?: number
  @Input() max?: number
  _formatDisplayValue: (val: number) => string | number = (val: number) => val
  disableMask = false
  edit = false
  @Input() disabled = true
  @Input() confirm = false
  @Input() viewValue : string
  @Input() set formatDisplayValue (value: (val: number) => string | number) {
    if (value) {
      this.disableMask = true
      this._formatDisplayValue = value
    }
  }
  _parseDisplayValue:  (val: string | number) => number = (val: string | number) => parseFloat(val.toString())
  @Input() set parseDisplayValue (value: (val: string | number) => number) {
    if (value)
      this._parseDisplayValue = value
  }
  @Output() onUpdateValue = new EventEmitter<number>()

  onManualInput($event: string) {
    if ($event.length) return
    let newValue = this._parseDisplayValue($event)
    if (newValue != this.initialValue) {
      this.initialValue = this._parseDisplayValue($event)
      if (!this.confirm) {
        this.onUpdateValue.emit(this.initialValue)
      }
    }
  }

  onConfirmInput() {
    if (this.confirm) {
      this.onUpdateValue.emit(this.initialValue)
    }
  }
}
